<template>
  <article>
    <div class="d-flex flex-column align-items-start h-100">
      <div class="d-flex justify-content-center justify-content-md-start">
        <img :src="article.image.url" :alt="article.image.alt">
      </div>
      <h3>{{ article.title }}</h3>
      <p class="flex-stretch">{{ article.description }}</p>
    </div>
  </article>
</template>

<script>
import Step from '@/assets/images/step.png'
import Step2 from '@/assets/images/step-2.png'
import Step3 from '@/assets/images/step-3.png'
export default {
  data(){
    return {
      stepImg: [Step, Step2, Step3]
    }
  },
  props: {
    article: {
      title: String,
      description: String,
      image: {
          url: String,
          alt:String
      }

    },
    index: Number
  }
}
</script>
